/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stock_Formal_Badger_StriveInputs */

const fr_stock_formal_badger_strive = /** @type {(inputs: Stock_Formal_Badger_StriveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun programme`)
};

/**

* @param {Stock_Formal_Badger_StriveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const stock_formal_badger_strive = /** @type {((inputs?: Stock_Formal_Badger_StriveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Formal_Badger_StriveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_stock_formal_badger_strive(inputs)
});